import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back\"><defs><style></style></defs><path d=\"M393.39 512.024L741.34 175.675c20.508-19.858 20.508-51.997 0-71.792-20.507-19.827-53.78-19.827-74.286 0L281.99 476.135c-20.476 19.827-20.476 51.982 0 71.746l385.062 372.237c10.285 9.914 23.728 14.87 37.174 14.87 13.446 0 26.889-4.957 37.112-14.902 20.508-19.826 20.508-51.92 0-71.746L393.39 512.024\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol